import { PersonType } from '@api';
import { z } from 'zod';

const personNotesFormSchema = z.object({
  notes: z.string().nullable(),
});

type PersonNotesFormSchemaType = typeof personNotesFormSchema;
export type PersonNotesFormValuesType = z.infer<PersonNotesFormSchemaType>;

type UsePersonNotesSchemaReturnType = {
  schema: PersonNotesFormSchemaType;
  defaultValues: PersonNotesFormValuesType;
};

export const usePersonNotesSchema = (
  personDetails: PersonType
): UsePersonNotesSchemaReturnType => {
  const defaultValues: PersonNotesFormValuesType = {
    notes: personDetails.notes,
  };

  return { schema: personNotesFormSchema, defaultValues };
};
